import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface NotionCxInputProps {
  onNotionCxChange: (value: string) => void;
  notionCxValue: string;
  isEnabled: boolean;
}

export const NotionCxInput: React.FC<NotionCxInputProps> = ({
  onNotionCxChange,
  notionCxValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="NOTION (CX)"
      label="Enter NOTION (CX) link:"
      placeholder="https://notion.so/..."
      value={notionCxValue}
      onChange={onNotionCxChange}
      isEnabled={isEnabled}
    />
  );
};